import { render, staticRenderFns } from "./CSupplierType.vue?vue&type=template&id=563c3fad&"
import script from "./CSupplierType.vue?vue&type=script&lang=js&"
export * from "./CSupplierType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports